/**
 * Centralized, typed access to environment variables.
 * Never read `import.meta.env` directly anywhere else in the app —
 * import `env` from here so a missing/misnamed var fails fast and loudly
 * in one place instead of silently as `undefined` deep in a component.
 */

function readString(key: string, fallback?: string): string {
  const value = import.meta.env[key] as string | undefined;
  if (value === undefined || value === '') {
    if (fallback !== undefined) return fallback;
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}

function readNumber(key: string, fallback: number): number {
  const raw = import.meta.env[key] as string | undefined;
  if (!raw) return fallback;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export const env = {
  apiBaseUrl: readString('VITE_API_BASE_URL', 'http://192.168.1.144:8000/api'),
  maxUploadMb: readNumber('VITE_MAX_UPLOAD_MB', 5),
  pricePerPage: readNumber('VITE_PRICE_PER_PAGE', 3),
  appEnv: readString('VITE_APP_ENV', 'development'),
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

console.log('VITE API BASE URL:', env.apiBaseUrl);